<template>
  <div class="my-main-content-web">
    <div style="margin-top:5vh;  padding-bottom: 48px;max-width: 1280px; margin-right: 8vw; margin-left: 8vw;">
      <h3 class="text3D">
        <span @click="$routerTo('/Admin')" style="border-bottom: 1px solid;cursor: pointer;">後台設定</span>
        <span> / </span>
        <span>管理 QRcode </span>

        <el-button class="no-print" type="success" @click="showAddDialog()" style="margin-top: 10px; margin-bottom: 10px">新增</el-button>
      </h3>

      <!-- 分類 -->
      <el-row style="margin-top: 10px">
        <el-row style="text-align: left">
          <!-- <el-col :xs="6" :sm="3"> <span style="color:red">*</span>選擇 </el-col> -->

          <el-col :xs="24" :sm="24">
            <!-- <el-select @change="queryQRcode" v-model="selected_qrcode" value-key="recno" placeholder="選擇QRcode">
            <el-option v-for="(item, index) in options_qrcode" :key="index" :label="item['name_zh-TW']" :value="item"></el-option>
          </el-select> -->

            <el-radio-group @change="queryQRcode" v-model="selected_qrcode">
              <el-radio v-for="(item, index) in options_qrcode" :key="index" :label="item" style="width:20%; margin:0;">{{ item["name_zh-TW"] }}</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>

        <el-button class="no-print" type="warning" @click="showEditDialog()" style="margin-top: 10px; margin-bottom: 10px">修改名稱</el-button>
        <hr />

        <div v-if="selected_qrcode">
          <el-row type="flex" justify="center" align="middle">
            <div style="margin-top: 10px; text-align: left">
              <div v-if="areas_1_options.length > 0">
                <span>一樓</span>
                <el-checkbox-group v-model="selected_area_1">
                  <el-checkbox style="color: white; padding: 3px; width: 70px" v-for="(area, index) in areas_1_options" :key="index" :label="area.recno"
                    >{{ area["area_zh-TW"] }}
                    <span v-if="area.selected == '1' && now_selected_areas_array.indexOf(area.recno) == -1" style="color:red">(已選)</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div v-if="areas_2_options.length > 0">
                <span>二樓</span>
                <el-checkbox-group v-model="selected_area_2">
                  <el-checkbox style="color: white; padding: 3px; width: 70px" v-for="(area, index) in areas_2_options" :key="index" :label="area.recno"
                    >{{ area["area_zh-TW"] }}
                    <span v-if="area.selected == '1' && now_selected_areas_array.indexOf(area.recno) == -1" style="color:red">(已選)</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div v-if="areas_3_options.length > 0">
                <span>三樓</span>
                <el-checkbox-group v-model="selected_area_3">
                  <el-checkbox style="color: white; padding: 3px; width: 70px" v-for="(area, index) in areas_3_options" :key="index" :label="area.recno"
                    >{{ area["area_zh-TW"] }}
                    <span v-if="area.selected == '1' && now_selected_areas_array.indexOf(area.recno) == -1" style="color:red">(已選)</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-row>

          <el-col :span="24">
            <el-button class="no-print" type="warning" @click="modifyQRcode()" style="margin-top: 10px; margin-bottom: 10px">更新</el-button>
          </el-col>
        </div>
      </el-row>

      <!-- 建立 -->
      <el-dialog title="新增" :visible.sync="dialogVisible_add" width="80%">
        <el-row style="margin-top: 10px">
          <el-row type="flex" justify="center" align="middle">
            <el-col :xs="6" :sm="3"> <span style="color:red">*</span>名稱 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_zh-TW']" placeholder="名稱"></el-input>
            </el-col>
          </el-row>

          <hr />

          <el-button @click="translate()" type="warning" size="sm">自動翻譯</el-button>
          <el-row style="margin-top: 10px">
            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>簡體 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_zh-CN']" placeholder="簡體"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>英語 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_en']" placeholder="英語"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>韓語 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_ko']" placeholder="韓語"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>日語 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_ja']" placeholder="日語"></el-input>
            </el-col>
          </el-row>

          <!-- <el-col :span="24">
          <el-button class="no-print" type="success" @click="postQRcode()" style="margin-top: 10px; margin-bottom: 10px">新增</el-button>
        </el-col> -->
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_add = false">取 消</el-button>
          <el-button type="primary" @click="postQRcode()">確 定</el-button>
        </span>
      </el-dialog>

      <!-- 修改 -->
      <el-dialog title="修改" :visible.sync="dialogVisible_edit" width="80%">
        <el-row style="margin-top: 10px">
          <el-row type="flex" justify="center" align="middle">
            <el-col :xs="6" :sm="3"> <span style="color:red">*</span>新名稱 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_zh-TW']" placeholder="名稱"></el-input>
            </el-col>
          </el-row>

          <el-button @click="translate()" type="warning" size="sm" style="margin-top: 10px">自動翻譯</el-button>
          <el-row style="margin-top: 10px">
            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>簡體 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_zh-CN']" placeholder="簡體"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>英語 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_en']" placeholder="英語"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>韓語 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_ko']" placeholder="韓語"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>日語 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model.trim="post['name_ja']" placeholder="日語"></el-input>
            </el-col>
          </el-row>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_edit = false">取 消</el-button>
          <el-button type="primary" @click="putQRcode()">確 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { tify, sify } from "chinese-conv";
import cloneDeep from "lodash.clonedeep";

export default {
  data() {
    return {
      dialogVisible_add: false,
      dialogVisible_edit: false,
      options_floor: ["1", "2", "3"],
      options_qrcode: [],
      areas_1_options: [],
      areas_2_options: [],
      areas_3_options: [],
      selected_area_1: [],
      selected_area_2: [],
      selected_area_3: [],
      now_selected_areas_array: [],
      selected_qrcode: "",
      post: {
        "name_zh-TW": "",
        "name_zh-CN": "",
        name_en: "",
        name_ko: "",
        name_ja: "",
        recno: ""
      },
      is_edit: false,
      is_add: false,
      is_sort: false
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.$store.commit("set_page", location.hash);
    this.init();
  },
  methods: {
    init() {
      this.post = {
        "name_zh-TW": "",
        "name_zh-CN": "",
        name_en: "",
        name_ko: "",
        name_ja: "",
        recno: ""
      };
      this.selected_qrcode = "";

      let qrcodes = JSON.parse(localStorage.getItem("qrcodes"));
      
      // 依照 name_zh-TW 欄位進行排序
      qrcodes.sort(function(a, b) {
        var nameA = a["name_zh-TW"].toUpperCase(); // 將名字轉換成大寫進行比較
        var nameB = b["name_zh-TW"].toUpperCase(); // 將名字轉換成大寫進行比較

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        return 0; // 名字相同的情況下保持原有順序
      });
      console.log(qrcodes);

      // 顯示排序後的結果
      this.options_qrcode = qrcodes;

      let selected_areas_array = [];
      qrcodes.forEach(el => {
        selected_areas_array = selected_areas_array.concat(el.areas);
      });
      console.log(selected_areas_array);

      let areas = JSON.parse(localStorage.getItem("areas"));

      this.areas_1_options = areas.filter(el => {
        return el.floor == 1;
      });
      this.areas_1_options.forEach(el => {
        if (selected_areas_array.indexOf(el.recno) > -1) {
          el.selected = "1";
        }
      });
      this.areas_2_options = areas.filter(el => {
        return el.floor == 2;
      });
      this.areas_2_options.forEach(el => {
        if (selected_areas_array.indexOf(el.recno) > -1) {
          el.selected = "1";
        }
      });
      this.areas_3_options = areas.filter(el => {
        return el.floor == 3;
      });
      this.areas_3_options.forEach(el => {
        if (selected_areas_array.indexOf(el.recno) > -1) {
          el.selected = "1";
        }
      });
    },
    showAddDialog() {
      this.init();
      this.dialogVisible_add = true;
    },
    showEditDialog() {
      if (!this.selected_qrcode) {
        this.$message.warning("必填欄位不可空白");
        return false;
      }
      this.dialogVisible_edit = true;
    },
    queryQRcode(val) {
      this.post["name_zh-TW"] = "";
      this.post["name_zh-CN"] = "";
      this.post["name_en"] = "";
      this.post["name_ko"] = "";
      this.post["name_ja"] = "";
      this.now_selected_areas_array = val.areas;

      this.options_qrcode.forEach(el => {
        if (el.recno == val.recno) {
          this.post = cloneDeep(el);
        }
      });

      this.selected_area_1 = [];
      this.selected_area_2 = [];
      this.selected_area_3 = [];

      this.areas_1_options.forEach(el => {
        if (val.areas.indexOf(el.recno) > -1) {
          this.selected_area_1.push(el.recno);
        }
      });

      this.areas_2_options.forEach(el => {
        if (val.areas.indexOf(el.recno) > -1) {
          this.selected_area_2.push(el.recno);
        }
      });

      this.areas_3_options.forEach(el => {
        if (val.areas.indexOf(el.recno) > -1) {
          this.selected_area_3.push(el.recno);
        }
      });
    },
    async putQRcode() {
      if (!this.post["name_zh-TW"] || !this.post["name_zh-CN"] || !this.post["name_en"] || !this.post["name_ko"] || !this.post["name_ja"]) {
        this.$message.warning("必填欄位不可空白");
        return false;
      }

      this.$store.commit("setLoadingMask", true);

      let obj = cloneDeep(this.post);
      delete obj.areas;

      await axios
        .put("/api/qrcode", obj)
        .then(response => {
          console.log(response);
          this.$message.success("修改成功");
          this.dialogVisible_edit = false;
        })
        .catch(error => {
          console.log(error.message);
        });

      await this.$getQRcode();

      this.init();

      this.$store.commit("setLoadingMask", false);
    },
    async postQRcode() {
      delete this.post.recno;

      if (!this.post["name_zh-TW"] || !this.post["name_zh-CN"] || !this.post["name_en"] || !this.post["name_ko"] || !this.post["name_ja"]) {
        this.$message.warning("必填欄位不可空白");
        return false;
      }
      this.$store.commit("setLoadingMask", true);

      await axios
        .post("api/qrcode", this.post)
        .then(response => {
          console.log(response);
          this.$message.success("新增成功");
          this.dialogVisible_add = false;
        })
        .catch(error => {
          console.log(error.message);
        });

      await this.$getQRcode();

      this.init();

      this.$store.commit("setLoadingMask", false);
    },
    async translate() {
      if (!this.post["name_zh-TW"]) {
        this.$message.warning("必填欄位，不可空白！");
        return false;
      }

      this.$store.commit("setLoadingMask", true);

      this.post["name_zh-CN"] = sify(this.post["name_zh-TW"]);

      let api_key = "AIzaSyDvidOES_35o1dylx-03Y8_9XGvNviN9oY";
      let text_en = "&q=" + this.post["name_zh-TW"];
      function getTranslateEn() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_en + "&target=en&source=zh&format=text");
      }
      let text_ko = "&q=" + this.post["name_zh-TW"];
      function getTranslateKo() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_ko + "&target=ko&source=zh&format=text");
      }
      let text_ja = "&q=" + this.post["name_zh-TW"];
      function getTranslateJa() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_ja + "&target=ja&source=zh&format=text");
      }

      await Promise.all([getTranslateEn(), getTranslateKo(), getTranslateJa()]).then(results => {
        console.log(results);
        this.post["name_en"] = results[0].data.data.translations[0].translatedText;;
        this.post["name_ko"] = results[1].data.data.translations[0].translatedText;;
        this.post["name_ja"] = results[2].data.data.translations[0].translatedText;;
      })
      .catch(e => {
        console.log(e)
        this.$message.warning("翻譯時似乎出了點問題，請聯繫開發人員！");
      })
      .finally(()=>{
        this.$store.commit("setLoadingMask", false);
      });

      
    },
    async modifyQRcode() {
      if (!this.selected_qrcode) {
        this.$message.warning("必填欄位不可空白");
        return false;
      }

      this.$store.commit("setLoadingMask", true);

      let areas = this.selected_area_1.concat(this.selected_area_2).concat(this.selected_area_3);

      let obj = {
        recno: this.selected_qrcode.recno,
        areas
      };
      await axios
        .put("api/qrcode", obj)
        .then(response => {
          console.log(response);
          this.$message.success("更新成功");
        })
        .catch(error => {
          console.log(error.message);
        });

      await this.$getQRcode();

      this.init();

      this.$store.commit("setLoadingMask", false);
    }
  }
};
</script>

<style scoped>
.el-checkbox is-disabled {
  color: red !important;
}
</style>
